<template>
  <v-dialog v-model="showModal" content-class="property-view-modal" width="90%">
    <v-card class="property-view-modal__container">
      <v-icon v-if="!isMobile" class="property-view-modal__close" @click.stop="$emit('close-modal', false)">
        close
      </v-icon>
      <v-icon v-else class="property-view-modal__back" @click.stop="$emit('close-modal', false)">
        chevron_left
      </v-icon>
      <detail-property-view v-if="homeInfo" :key="homeInfo._id" :property-object-id="homeInfo._id" />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import DetailPropertyView from '../search/property_view/DetailPropertyView.vue'

export default {
  components: { DetailPropertyView },
  props: {
    homeInfo: {
      type: Object,
      default: () => ({})
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      modalShowing: false
    }
  },

  computed: {
    ...mapState('style', ['modal']),
    ...mapState('common', ['isMobile'])
  }
}
</script>

<style lang="sass">
*
  box-sizing: border-box
.property-view-modal
  @media only screen and (max-width: 450px)
    margin: 0 !important
.property-view-modal__container
  padding: 1.5rem 5rem
  min-height: 60vh
  width: 100%

.property-view-modal__close
  @extend %modal__button-close, %disable-selection

#containerData
  margin-top: 2rem

.data-header
  background-color: $hwayzDarkerGray
  color: hwayzWhite
  padding: 1rem 2rem !important

.data-header-fill
  background-color: $hwayzDarkerGray

.item-pair
  padding: 1rem 2rem !important
  color: $hwayzDarkerGray
.property-view-modal__close
  position: fixed
  top: 6.5%
  right: 6%
.property-view-modal__back
  position: absolute
  top: 8px
  left: 6px
  font-size: 35px !important
  cursor: pointer
</style>
